module.exports = __webpack_public_path__ + "img/zz_kj.ca8bee5e.png";